import React from "react";
import { motion } from "framer-motion";
import my_image from '../images/linkedIn.jpg';

export default function Home(){

    return(
        <div id="main">
        <section id="home">
            <div id="heroContainer">
                 <div id="heroText">
                      <p id="heroKicker">Shashank Bidhuri</p>
                      <p className="eyebrow">Full-Stack Software Engineer · Agentic AI &amp; LLM Systems</p>
                      {/* Single real H1 on the page, for both SEO and assistive tech. */}
                      <h1 id="heroHeading">
                          I build production web apps — <span className="heroAccent">and the AI agents that extend them.</span>
                      </h1>
                      <p id="heroSubtext">
                          2.5 years shipping full-stack systems in React and Node at ENTNT. Now applying that
                          the same way to the LLM layer — multi-agent orchestration, RAG, and MCP-based tooling
                          that removes real manual work, not demo work.
                      </p>
                      <div id="heroCTAs">
                          <a href="/resume.pdf" target="_blank" rel="noreferrer" className="ctaPrimary">Download Resume</a>
                          <a href="#contactMe" className="ctaSecondary">Get in Touch</a>
                      </div>
                      <div id="socials">
                        <a href="https://github.com/justShashank57" target="_blank" rel="noreferrer" className="socialIcon" aria-label="GitHub">
                            <img src="square-github.svg" alt="" />
                        </a>
                        <a href="https://www.linkedin.com/in/shashank-bidhuri-47a892249/" target="_blank" rel="noreferrer" className="socialIcon" aria-label="LinkedIn">
                            <img src="linkedin.svg" alt="" />
                        </a>
                    </div>
                 </div>
                 <motion.div
                    id="heroVisual"
                    initial={{ opacity: 0, scale: 0.92 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                 >
                    <div id="heroAvatarRing">
                        <motion.div id="heroAvatarInner" whileHover={{ scale: 1.03 }} transition={{ duration: 0.2 }}>
                           <img src={my_image} id="myPhoto" alt="Shashank Bidhuri" />
                        </motion.div>
                    </div>
                 </motion.div>
            </div>
         </section>
        </div>
    )
}
